import {
  Dashboard,
  Help,
  NotificationsNone,
  Payment,
  Person,
  Settings,
  ShoppingBag,
} from '@mui/icons-material';
import { userProfilePath } from '../../constants/userRoutes';

// Itens de navegação compartilhados entre a sidebar desktop e o menu mobile.
// Ordem: o painel é a página inicial do cliente; em seguida o que ele mais usa
// (pedidos) e só depois o perfil.
export const getUserNavItems = (userId) => [
  {
    icon: Dashboard,
    text: 'Dashboard',
    short: 'Painel',
    path: '/user/dashboard',
    tour: 'nav-dashboard',
  },
  {
    icon: ShoppingBag,
    text: 'Meus Pedidos',
    short: 'Pedidos',
    path: '/user/orders',
    tour: 'nav-orders',
  },
  {
    icon: Person,
    text: 'Meu perfil',
    short: 'Perfil',
    path: userProfilePath(userId),
    tour: 'nav-profile',
  },
  {
    icon: Payment,
    text: 'Pagamentos',
    short: 'Pagamentos',
    path: '/user/payments',
    tour: 'nav-payments',
  },
  {
    icon: NotificationsNone,
    text: 'Notificações',
    short: 'Alertas',
    path: '/user/notificacoes',
    tour: 'nav-notificacoes',
  },
  {
    icon: Settings,
    text: 'Configurações',
    short: 'Ajustes',
    path: '/user/settings',
    tour: 'nav-settings',
  },
  { icon: Help, text: 'Ajuda', short: 'Ajuda', path: '/user/help', tour: 'nav-help' },
];

export const isNavItemActive = (pathname, path) => {
  if (!path) return false;
  if (
    path === '/user/dashboard' ||
    path === '/user/orders' ||
    path === '/user/payments' ||
    path === '/user/settings' ||
    path === '/user/help'
  ) {
    return pathname === path;
  }
  return pathname === path;
};
